// extracted by mini-css-extract-plugin
export default {"detailsWrapper":"info-section_detailsWrapper__SOR8z","statSummary":"info-section_statSummary__rAyhu","item":"info-section_item__2FFqD","required":"info-section_required__AWNaR"};